import { useState } from 'react';
import { Button } from '@vinted/web-ui';
import { noop } from 'lodash';
import { FACEBOOK_PERMISSIONS, FacebookLoginStatus } from 'constants/auth';
import useInitFacebook from './useInitFacebook';
import { jsx as _jsx } from "react/jsx-runtime";

const FacebookButton = _ref => {
  let {
    text,
    isLoading,
    onClick = noop,
    onSuccess,
    onFailure = noop
  } = _ref;
  const {
    0: isFbLoginLoading,
    1: setIsFbLoginLoading
  } = useState(false);
  const {
    isInitialized,
    isEnabled
  } = useInitFacebook();

  const handleClick = () => {
    onClick();
    setIsFbLoginLoading(true);
    FB.login(response => {
      if (response.status !== FacebookLoginStatus.Connected) {
        onFailure();
        setIsFbLoginLoading(false);
        return;
      }

      try {
        FB.api('/me', {
          fields: ['email', 'birthday', 'gender', 'name', 'first_name', 'last_name']
        }, fields => {
          onSuccess(response.authResponse.accessToken, fields);
        });
      } catch (exception) {
        var _window$apphealth;

        (_window$apphealth = window.apphealth) === null || _window$apphealth === void 0 ? void 0 : _window$apphealth.captureError(exception); // Calling success because the user is still allowed to login

        onSuccess(response.authResponse.accessToken, {});
      } finally {
        setIsFbLoginLoading(false);
      }
    }, {
      scope: FACEBOOK_PERMISSIONS
    });
  };

  if (!isEnabled) return null;
  return /*#__PURE__*/_jsx(Button, {
    theme: "amplified",
    iconName: "signup/facebook",
    onClick: handleClick,
    disabled: !isInitialized || isLoading || isFbLoginLoading,
    isLoading: isLoading || isFbLoginLoading,
    children: text
  });
};

export default FacebookButton;